import { render, staticRenderFns } from "./english-big-training-questions.vue?vue&type=template&id=8c3168fc&scoped=true&"
import script from "./english-big-training-questions.vue?vue&type=script&lang=js&"
export * from "./english-big-training-questions.vue?vue&type=script&lang=js&"
import style0 from "./english-big-training-questions.vue?vue&type=style&index=0&id=8c3168fc&scoped=true&lang=scss&"
import style1 from "./english-big-training-questions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3168fc",
  null
  
)

export default component.exports